const CATEGORY_RULES = [
    { category: 'Moradia', keywords: ['aluguel', 'condominio', 'condomínio', 'energia', 'luz', 'agua', 'água', 'internet', 'iptu', 'gas', 'gás'] },
    { category: 'Alimentação', keywords: ['mercado', 'supermercado', 'padaria', 'restaurante', 'ifood', 'lanche', 'pizza', 'comida'] },
    { category: 'Transporte', keywords: ['uber', '99', 'combustivel', 'combustível', 'gasolina', 'onibus', 'ônibus', 'metro', 'metrô', 'estacionamento'] },
    { category: 'Saúde', keywords: ['farmacia', 'farmácia', 'medico', 'médico', 'consulta', 'exame', 'plano de saude', 'plano de saúde'] },
    { category: 'Educação', keywords: ['curso', 'faculdade', 'escola', 'livro', 'mensalidade'] },
    { category: 'Lazer', keywords: ['cinema', 'netflix', 'spotify', 'show', 'viagem', 'hotel', 'bar'] },
    { category: 'Cartão', keywords: ['cartao', 'cartão', 'nubank', 'itau', 'itaú', 'inter', 'c6', 'visa', 'mastercard'] },
    { category: 'Salário', keywords: ['salario', 'salário', 'pro labore', 'pró labore', 'pagamento', 'renda'] },
    { category: 'Investimentos', keywords: ['investimento', 'aplicacao', 'aplicação', 'tesouro', 'cdb', 'poupanca', 'poupança'] },
];

export const normalizeText = (value = '') =>
    value
        .toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

export const inferCategory = (transaction = {}) => {
    const text = normalizeText(`${transaction.description || ''} ${transaction.cardName || ''}`);
    const match = CATEGORY_RULES.find(rule =>
        rule.keywords.some(keyword => text.includes(normalizeText(keyword)))
    );

    if (match) return match.category;
    return transaction.type === 'income' ? 'Receitas' : 'Outros';
};

export const buildCategoryOptions = (transactions = []) => {
    const categories = transactions
        .map(transaction => transaction.category || inferCategory(transaction))
        .filter(Boolean);

    return [...new Set(categories)].sort((a, b) => a.localeCompare(b, 'pt-BR'));
};
